// extracted by mini-css-extract-plugin
export default {"container":"Card_container__SAu6P","hasBorder":"Card_hasBorder__P-Dj4","title":"Card_title__kiqRr"};